import { render, staticRenderFns } from "./FinanceSalarySliceShowEmployee.vue?vue&type=template&id=dc4b284e&"
import script from "./FinanceSalarySliceShowEmployee.vue?vue&type=script&lang=js&"
export * from "./FinanceSalarySliceShowEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports